import { render, staticRenderFns } from "./CommissionConfigShow.vue?vue&type=template&id=8eec7fdc&"
import script from "./CommissionConfigShow.vue?vue&type=script&lang=js&"
export * from "./CommissionConfigShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports